<template>
  <div class="landing-page-container">
    <div v-if="!showOops">
      <div class="landing-graphic">
        <div class="landing-icon">
          <img class="icon" src="../assets/img/weChatIcon.svg" @click="showWxModal"/>
          <img class="icon" src="../assets/img/instagramIcon.svg" @click="openNewWindow('https://www.instagram.com/asianfamilymarket/?hl=en')"/>
<!--          <img class="icon" src="../assets/img/facebookIcon.svg"/>-->
        </div>
        <div class="welcome">
          <p class="welcome-logo">
            <img src="../assets/img/afm-logo.png" alt="">
            <span @click="langChanged">中文 / EN</span>
          </p>
          <p class="welcome-title">{{ $t('by_asian_family') }}</p>
          <p class="welcome-intro">By Asian Family Market</p>
          <p class="welcome-desc">{{ $t('favoriteAsianGroceries') }}</p>
          <p class="welcome-desc">{{ $t('deliveryDoor') }}</p>
          <div class="welcome-buttons">
            <button class="welcome-button" @click="goToHome()">{{ $t('pick_up') }}</button>

            <div class="delivery-button-container"
                 :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}">
              <input
                type="text"
                :placeholder="zipcodeRequiredWarning ? $t('enter_zipcode_star') : $t('enter_zip_code')"
                v-model="zipcode"
                class="landing-subscribe-field"
                :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}"
                @keyup.enter="enterZip($event)"
              />
              <div @click="enterZip($event)" class="landing-icon-container">
                <!-- <font-awesome-icon
                  icon="paper-plane"
                  :style="{ color: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a', fontSize: '28px' }"
                /> -->
                {{ $t('delivery') }}
              </div>
            </div>

          </div>
          <div class="welcome-blurb">
            <div class="welcome-border"></div>
            <p class="blurb">{{ $t('same_day_delivery') }}</p>
            <p class="blurb">{{ $t('free_delivery_over') }}</p>
            <p class="blurb">{{ $t('off_first_order') }}</p>
          </div>
        </div>

        <div class="get-started" v-if="isMobile">

          <button class="welcome-button" @click="goToHome()">{{ $t('pick_up') }}</button>
          <div class="zip-button-container" :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}">
            <!-- set to number type in mobile code -->
            <input
              type="tel"
              pattern="\d*"
              :placeholder="zipcodeRequiredWarning ? $t('enter_zipcode_star') : $t('enter_zip_code')"
              v-model="zipcode"
              class="landing-subscribe-field"
              :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}"
            />
            <div @click="enterZip($event)" class="landing-icon-container">
              {{ $t('delivery') }}
              <!-- <img src="../assets/img/enter-hover.svg" style="width: 60%; margin-right: 2px;margin-top: 2px;" /> -->
<!--              <font-awesome-icon icon="paper-plane"-->
<!--                                 :style="{ color: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a', fontSize: '28px' }"/>-->
            </div>
          </div>

<!--          <div class="delivery-button-container"-->
<!--               :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}">-->
<!--            <input-->
<!--              type="text"-->
<!--              :placeholder="zipcodeRequiredWarning ? $t('zipCode_afm') : $t('delivery_afm')"-->
<!--              v-model="zipcode"-->
<!--              class="landing-subscribe-field"-->
<!--              :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}"-->
<!--            />-->
<!--            <div @click="enterZip($event)" class="landing-icon-container">-->
<!--              <font-awesome-icon icon="paper-plane"-->
<!--                                 :style="{ color: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a', fontSize: '28px' }"/>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="graphic">
          <img src="../assets/img/landingPageGraphic.png"/>
          <p class="landing-text">{{ $t('price_online_only') }}</p>
        </div>
      </div>

      <div class="how-it-works">
        <p class="hiw-title">{{ $t('how_it_works') }}</p>
        <div class="bubble-container">
          <div class="bubble-content">
            <img class="bubble-img" src="../assets/img/magnifyIcon.svg"/>
            <p class="bubble-header">{{ $t('enter_zip_code') }}</p>
            <p class="bubble-desc">{{ $t('zip_cities') }}</p>
          </div>
          <div class="bubble-content">
            <img class="bubble-img" src="../assets/img/cartButton.svg"/>
            <p class="bubble-header">{{ $t('add_items_to') }}</p>
            <p class="bubble-desc">{{ $t('asian_family_market') }}</p>
          </div>
          <div class="bubble-content">
            <img class="bubble-img" src="../assets/img/calendarIcon.svg"/>
            <p class="bubble-header">{{ $t('select_delivery_time') }}</p>
            <p class="bubble-desc">{{ $t('same_day_delivery_or') }}</p>
          </div>
          <div class="bubble-content">
            <img class="bubble-img" src="../assets/img/truckIcon.svg"/>
            <p class="bubble-header">{{ $t('delivery_to_your') }}</p>
            <p class="bubble-desc">{{ $t('find_favorite_products') }} - {{ $t('delivered_front_door') }}</p>
          </div>
        </div>
      </div>

      <div class="category-buttons">
        <p class="hiw-title">{{ $t('shop_by_categories') }}</p>
        <ul>
          <li v-for="(item, index) in groups">
            <div class="group-button-container">
              <div class="image-placeholder" @click="navGo(item)">
                <img class="button-image" :src="item.Image" alt="">
              </div>
              <p v-if="$i18n.locale == 'en'" class="group-button-name">{{ item.Name }}</p>
              <p v-if="$i18n.locale == 'ch'" class="group-button-name">{{ item.Description }}</p>
            </div>
          </li>
        </ul>
      </div>

      <div class="map-container">
        <div class="zip-content">
          <p class="zip-header">{{ $t('areas_we_deliver') }}</p>
          <p class="zip-blurb">{{ $t('we_are_expanding') }}</p>
          <div class="zip-selection">
            <div class="button-holder" v-for="location in this.deliveryAreas">
              <button class="maps-button" @click="setGoogleMapLocation(location)">{{ location.name }}</button>
            </div>
          </div>
        </div>
        <div class="map">
          <!-- <img class="map-image" src="../assets/img/seattle.png" /> -->
          <div id="map" style="height:100%;width:100%;"/>
          <div style="display: none;">
            <GmapMap
              :center='center'
              :zoom='this.googleZoom'
              :minZoom='8'
              style='width:100%;  height: 100%;'
            >
              <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
              />
            </GmapMap>
          </div>
        </div>
      </div>

      <div class="get-started" v-if="!isMobile">
        <p class="hiw-title">{{ $t('start_order_now') }}</p>
        <div class="zip-button-container" :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}">
          <input
            type="text"
            :placeholder="zipcodeRequiredWarning ? $t('enter_zipcode_star') : $t('enter_zip_code')"
            v-model="zipcode"
            class="landing-subscribe-field"
            :style="{background: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a'}"
          />
          <div @click="enterZip($event)" class="landing-icon-container">
            <!-- <font-awesome-icon icon="paper-plane" :style="{ color: zipcodeRequiredWarning ? '#FA6400' : '#7cc26a', fontSize: '28px' }"/> -->
            {{ $t('delivery') }}
          </div>
        </div>
      </div>
    </div>

    <div class="oops-page-container" v-if="showOops">
      <img style="margin-bottom: 50px" class="oops-img" src="../assets/img/oops_zipcode.png"/>
      <p class="type1">{{ $t('oops') }}……</p>
      <p style="margin-bottom: 20px" class="type1">{{ $t('your_location_is') }} </p>
      <p style="margin-bottom: 20px" class="type2">{{ $t('be_the_first') }}</p>
      <p style="margin-bottom: 20px" class="type3">{{ $t('you_also_get') }}</p>
      <div class="subscribe-button-container">
        <input
          type="text"
          :placeholder="$t('enter_email')"
          v-model="subscribeEmail"
          class="landing-subscribe-field"
          @keyup.enter="enterEmail($event)"
        />
        <div v-if="subscribeEmailStatus === 'default'" @click="enterEmail($event)" class="landing-icon-container">
          <i class="fa fa-envelope-o" aria-hidden="true" :style="{ color: '#7cc26a', fontSize: '26px' }"></i>
        </div>
        <div v-if="subscribeEmailStatus === 'success'" class="landing-icon-container">
          <i class="fa fa-check" aria-hidden="true" :style="{ color: '#7cc26a', fontSize: '26px' }"></i>
        </div>
        <div v-if="subscribeEmailStatus === 'error'" class="landing-icon-container">
          <i class="fa fa-times" aria-hidden="true" :style="{ color: '#FA6400', fontSize: '26px' }"></i>
        </div>
      </div>
      <div style="width: 300px; display: flex; justify-content: center">
        <p style="margin-top: 20px; margin-right: 10px; text-decoration: underline; cursor: pointer;" class="type3"
           @click="stillBrowse">{{ $t('still_browse') }}</p>
        <p style="margin-top: 20px; text-decoration: underline; cursor: pointer; text-decoration-skip-ink: none;"
           class="type3" @click="tryAgain">
          {{ $t('tryAgain') }}</p>
      </div>
      <div class="mobile-locales" v-if="isMobile">
        <p class="type1">{{ $t('where_we_deliver') }}</p>
        <p class="type4">{{ $t('we_will_expand') }}</p>
        <div class="zip-selection">
          <div class="button-holder" v-for="location in this.deliveryAreas">
            <button class="maps-button">{{ location.name }}</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import {gmapApi} from 'vue2-google-maps'
import {googleStyle} from './googleMapStyle';
import {locales} from "../mixin";

const PICKUP_KEY = 'Pickup'
const DELIVERY_KEY = 'Delivery'

export default {
  name: "landingPage",
  mixins: [locales],
    props: {
    idata: {
      type: String,
    }
  },
  data() {
    return {
      mapRef: null,
      googleStyle: googleStyle,
      center: {lat: 47.678013, lng: -122.255167},
      googleZoom: 10,
      markers: [
        {position: {lat: 47.828637272341204, lng: -122.30598433396976}},
        {position: {lat: 47.76918395614945, lng: -122.20562923564746}},
        {position: {lat: 47.75585896069335, lng: -122.34351256292}},
        {position: {lat: 47.679809121763256, lng: -122.1312518227799}},
        {position: {lat: 47.71485595518293, lng: -122.21802536669493}},
        {position: {lat: 47.59786514937365, lng: -122.15937288320275}},
        {position: {lat: 47.6143318525307, lng: -122.31323169137016}},
        {position: {lat: 47.53131383166128, lng: -122.16031942017412}},
        {position: {lat: 47.47186673009948, lng: -122.19722844999497}},
        {position: {lat: 47.53734365216002, lng: -122.04739218292258}},
      ],
      deliveryAreas: [
        {name: 'Lynnwood', lat: 47.828637272341204, lng: -122.30598433396976},
        {name: 'Bothell', lat: 47.76918395614945, lng: -122.20562923564746},
        {name: 'Shoreline', lat: 47.75585896069335, lng: -122.34351256292},
        {name: 'Redmond', lat: 47.679809121763256, lng: -122.1312518227799},
        {name: 'Kirkland', lat: 47.71485595518293, lng: -122.21802536669493},
        {name: 'Bellevue', lat: 47.59786514937365, lng: -122.15937288320275},
        {name: 'Seattle', lat: 47.6143318525307, lng: -122.31323169137016},
        {name: 'Newcastle', lat: 47.53131383166128, lng: -122.16031942017412},
        {name: 'Renton', lat: 47.47186673009948, lng: -122.19722844999497},
        {name: 'Issaquah', lat: 47.53734365216002, lng: -122.04739218292258},
      ],
      zipcode: '',

      zipcodeRequiredWarning: false,
      showOops: false,
      subscribeEmail: '',
      subscribeEmailStatus: 'default',
      getMapTimeoutId: null
    }
  },
  methods: {
    ...mapMutations('navbar', ['toggleRegisterModalVisibility', 'toggleWarehouseSelectionModalVisibility', 'updateShippingMethodGlobal', 'validateRadiusHome', 'validateRadiusPurchase', 'toggleModal', 'resetHomeWithinRadius', 'resetHomeRadiusChecked', 'updateWarehouseLocation', 'showWxModal']),
    ...mapActions('profile', ['fetchSubscribeEmail', 'postSubscribeEmail', 'putUnsubscribeEmail']),
    resetPage() {
      this.subscribeEmail = '';
      this.showOops = false;
      this.zipcodeRequiredWarning = false;
      this.zipcode = '';
    },
    enterZip(e) {
      e.preventDefault();
      if (!this.zipcode) {
        this.zipcodeRequiredWarning = true;
        return;
      }
      // if (this.zipcode.length === 5) {
      this.updateShippingMethodGlobal(DELIVERY_KEY);
      this.$store.dispatch('navbar/validateDeliveryRadius', this.zipcode);
      // // } else {
      // }
      this.resetHomeWithinRadius();
    },
    goToHome() {
      localStorage.setItem('goToHome', true)
      this.updateShippingMethodGlobal(PICKUP_KEY);
      this.toggleWarehouseSelectionModalVisibility(true);
      // if (!localStorage.getItem('warehouseLocationWeb')) {
      //   this.toggleWarehouseSelectionModalVisibility(true);
      // } else {
      //   this.$router.push(`/home`);
      // }
    },
    navGo(group) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewGroup(group);
      }, 600);
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    enterEmail(e) {
      //  console.log("subscribe", this.subscribeEmail);
      if (this.subscribeEmail) {
        if (this.validEmail(this.subscribeEmail)) {
          this.postSubscribeEmail(this.subscribeEmail)
            .then(res => {
              this.subscribeEmailStatus = 'success';
            }).catch(err => {
            this.subscribeEmailStatus = 'error';
            setTimeout(() => {
              this.subscribeEmailStatus = 'default';
            }, 800);
          });
        } else {
          this.subscribeEmailStatus = 'error';
          setTimeout(() => {
            this.subscribeEmailStatus = 'default';
          }, 800);
        }
      }
      //  alert('Subscription in development');
    },
    stillBrowse() {
      // this.$store.dispatch('navbar/validateDeliveryRadius', '98007');
      // this.resetHomeWithinRadius();
      this.updateShippingMethodGlobal(PICKUP_KEY);
      this.$router.push('/home');
    },
    externalSetOops() {
      this.showOops = true;
    },
    tryAgain() {
      this.resetPage();
      document.documentElement.scrollTop = 0;
    },
    setGoogleMapLocation(location) {
      this.center = {lat: location.lat, lng: location.lng};
      this.googleZoom = 12;
      this.initGmap();
    },
    initGmap() {
      const google = this.google
      if (!google) {
        this.getMapTimeoutId = setTimeout(() => {
          this.initGmap()
        }, 1000)
        return
      }
      this.mapRef = new google.maps.Map(document.getElementById('map'), {
        center: this.center,
        zoom: this.googleZoom,
        // styles: googleStyle,
      });

      this.markers.map(row => {
        new window.google.maps.Marker({
          position: row.position,
          map: this.mapRef,
        });
      });
    },
    openNewWindow(url) {
      url && window.open(url)
    },
    checkShippingMethodAndJump() {
      const shippingMethodGlobal = localStorage.getItem('shippingMethodGlobal')
      if (!shippingMethodGlobal) return
      switch (shippingMethodGlobal) {
        case PICKUP_KEY:
          this.goToHome()
          const warehouseLocationWeb = localStorage.getItem('warehouseLocationWeb') || ''
          const fun = this.$root.navbarSelectLocation
          typeof fun === 'function' && fun(warehouseLocationWeb)
          break
        case DELIVERY_KEY:
          this.zipcode = localStorage.getItem('userZipcode') || ''
          this.enterZip({preventDefault: () => {}})
          break
      }
    }
  },
  computed: {
    ...mapState({
      groups: state => state.navbar.allGroups,
      homeWithinRadius: state => state.navbar.homeWithinRadius,
      windowWidth: state => state.navbar.windowWidth,
      isMobile() {
        return this.windowWidth < 800;
      }
    }),
    google: gmapApi
  },
  mounted() {
    this.$root.externalSetOops = this.externalSetOops.bind(this);
    this.$root.resetPage = this.resetPage.bind(this);
    document.documentElement.scrollTop = 100;
    this.initGmap();
    if (this.idata) {
      this.toggleRegisterModalVisibility(true);
    }
    // console.log("idata", this.idata);
  },
  activated() {
    localStorage.removeItem('goToHome')
  },
  deactivated() {
    clearTimeout(this.getMapTimeoutId)
  },
  watch: {
    homeWithinRadius: function (newVal, oldVal) {
      if (newVal === false) {
        // console.log("not within radius");
        this.showOops = true;
        document.documentElement.scrollTop = 150;
      }
      if (newVal === true && this.$router.currentRoute.path === '/') {
        // console.log("within radius");
        this.$router.push('/home');
      }
    },
    $route(to, from) {
      this.resetPage();
    }
  },
  created() {
    this.checkShippingMethodAndJump()
  }
}
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/landingPage.less";
@import "../assets/query/landingPage.less";
</style>



// WEBPACK FOOTER //
// src/view/landingPage.vue